import React, { Component } from "react";
import TextEditor from "./TextEditor";
import CommonEditor from "./CommonEditor";
import { DKLabel, DKButton, DKIcons, showAlert } from "deskera-ui-library";
import { PAGE_ELEMENT } from "../ComponentList";
import ButtonEditor from "./ButtonEditor";
import ImagePicker from "./ImagePicker";
import VideoSectionEditor from "./VideoSectionEditor";
import SocialSectionEditor from "./SocialSectionEditor";
import CollectionSectionEditor from "./CollectionSectionEditor";
import ImageTextEditor from "./ImageTextEditor";
import FormEditor from "./FormEditor";
import CustomHtmlEditor from "./CustomHtmlEditor";

/*
PROPS
- pageType (PAGE_TYPE)
- data // this is current componets data
- onDataChange
- onClose
- onDelete
*/

class Editor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      componentData: this.props.data,
    };
  }
  componentWillReceiveProps(props) {
    this.setState({
      componentData: props.data,
    });
  }

  render() {
    return (
      <div className="editor-background-mobile parent-height ml-xl">
      <div
        className=" bg-white border-radius-s border-box p-l shadow-s ml-xl hide-scroll-bar "
        id="page-designer-editor"
        style={{
          width: 300,
          maxHeight: "100%",
          overflowY: "scroll",
          paddingBottom: 100,
          marginLeft: "auto"
        }}
      >
        <div className="row justify-content-between mb-r">
          <DKLabel text={`Editor`} className="fw-b fs-m " />
          <div className="row" style={{ width: "auto" }}>
            {/* {this.props.data.type === PAGE_ELEMENT.FORM &&
            this.props.pageType === PAGE_TYPE.FORM ? null : (
              <DKButton
                icon={DKIcons.white.ic_delete}
                onClick={this.onDelete}
                className="bg-red text-white"
              />
            )} */}
            <DKButton
              icon={DKIcons.ic_close}
              onClick={this.props.onClose}
              className="bg-gray1 border-m ml-r"
            />
          </div>
        </div>
        {this.state.componentData.type === PAGE_ELEMENT.IMAGE && (
          <ImagePicker
            data={this.state.componentData}
            onDataChange={this.props.onDataChange}
            className="mt-m"
          />
        )}

        {this.state.componentData.type === PAGE_ELEMENT.VIDEO && (
          <VideoSectionEditor
            data={this.state.componentData}
            onDataChange={this.props.onDataChange}
            className="mt-m"
          />
        )}

        {this.state.componentData.type === PAGE_ELEMENT.SOCIAL_BUTTONS && (
          <SocialSectionEditor
            data={this.state.componentData}
            onDataChange={this.props.onDataChange}
          />
        )}

        {(this.state.componentData.type === PAGE_ELEMENT.COLLECTION ||
          this.state.componentData.type === PAGE_ELEMENT.ICON) && (
          <CollectionSectionEditor
            data={this.state.componentData}
            onDataChange={this.props.onDataChange}
          />
        )}

        {this.state.componentData.type === PAGE_ELEMENT.IMAGE_TEXT && (
          <ImageTextEditor
            data={this.state.componentData}
            onDataChange={this.props.onDataChange}
          />
        )}

        {this.state.componentData.type === PAGE_ELEMENT.FORM && (
          <FormEditor
            data={this.state.componentData}
            onDataChange={this.props.onDataChange}
            pageType={this.props.pageType}
          />
        )}

        {this.state.componentData.type === PAGE_ELEMENT.BUTTON && (
          <ButtonEditor
            data={this.state.componentData}
            onDataChange={this.props.onDataChange}
            pageType={this.props.pageType}
          />
        )}
        {( this.state.componentData.type === PAGE_ELEMENT.BUTTON ||
          this.state.componentData.type === PAGE_ELEMENT.TEXT) && (
          <TextEditor
            data={this.state.componentData}
            onDataChange={this.props.onDataChange}
            onClose={this.props.onClose}
          />
        )}
        {this.state.componentData.type === PAGE_ELEMENT.CUSTOM_HTML && (
          <CustomHtmlEditor
            data={this.state.componentData}
            onDataChange={this.props.onDataChange}
            pageType={this.props.pageType}
          />
        )}
        <CommonEditor
          data={this.state.componentData}
          onDataChange={this.props.onDataChange}
        />
      </div>
      </div>
    );
  }

  onDelete = () => {
    const buttons = [
      {
        title: "Cancel",
        className: "bg-gray1 border-m",
      },
      {
        title: "Delete",
        className: "bg-red text-white ml-r",
        onClick: () => {
          this.props.onDelete();
        },
      },
    ];
    showAlert(
      "Delete element?",
      "Deleting this element will delete it permanently.",
      buttons
    );
  };
}

export default Editor;
